<template>
  <div class="ticket-entrance">
    <a :href="link" target="_blank">
      <img :src="image" alt="">
    </a>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'TicketEntrance',
    computed: {
      ...mapState({
        link: state => state.ticketEntrance.link,
        image: state => state.ticketEntrance.image,
      })
    }
  };
</script>

<style scoped lang="less">
  .ticket-entrance {
    width: 138vh;
    height: 100vh;
    text-align: center;
  }

  a {
    display: block;
    width: 100%;
    height: 100%;

    img {
      height: 100%;
    }
  }
</style>
